import { createSlice } from '@reduxjs/toolkit';
import { logger } from '../utils/logger';
import { set } from 'lodash';

const initialState = {
	selectedSubTopicData: {
		topicId: '',
		topicName: '',
		subtopicId: '',
		subtopicName: '',
		notebookId: '',
		subject: '',
	},
	topiclist: {},
};

const selectedSubTopicSlice = createSlice({
	name: 'selectedSubTopic',
	initialState,
	reducers: {
		setSelectedSubTopicData: (state, action) => {
			logger.log('Payload received in reducer:', action.payload);
			state.selectedSubTopicData = action.payload; // Replace with single object
		},
		setTopicList: (state, action) => {
			state.topiclist = action.payload.reduce((acc, topicObj) => {
				acc[topicObj.TOPIC_ID] = {
					subtopics: topicObj.SUBTOPICS,
					topicName: topicObj.TOPIC_NAME,
				};
				return acc;
			}, {});
		},
	},
});

export const { setSelectedSubTopicData, setTopicList } = selectedSubTopicSlice.actions;

export default selectedSubTopicSlice.reducer;
